import "./styles.css";
import Header from "./Header";
import Bots from "./Bots";

/*
to do-
1. header title - done
2. a card with conrols for each robot 
    in house.
3. Footer giving out the details-
    a. Home address
    b. Name of product and year developed.
    c. developed by who?
*/
export default function App() {
  return (
    <div className="App">
      <Header />
      <Bots />
      <h1>Hello CodeSandb</h1>
      <h2>Start editing to see ssomde magic happen!</h2>
    </div>
  );
}
